import { createResourceListQuery } from '@hooks/resourceListPage';
import { getUsers, usersQueryKeys } from '../../api/users';
import type { FetchUsersParams, UsersResponse } from '../../api/users';

export const useUsers = createResourceListQuery<UsersResponse, FetchUsersParams>({
  queryKey: (params) => usersQueryKeys.list(params),
  fetcher: getUsers,
});
